import React, { FC } from 'react';
import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { Private } from '#/containers/router/routes/Private';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { useI18n } from '#hooks/useI18n';

interface TeamProps extends SectionProps {
}

export const Team: FC<TeamProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return <Can hasRoles={['admin']}>
    <NavigationLink to={Private.TEAM.route} onClick={onClickItem} depth={depth} icon="people" title={t('asideNavigation.team')} isMobile={isMobile}/>
  </Can>;
};
